// extracted by mini-css-extract-plugin
export default {"main-footer-container":"MainFooter_main-footer-container__JOhlw"};